import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../../../../../common/constants/common-constants';
import { QuickCallResponse } from '../model/quickcallresponse';

@Injectable()
export class QuickCallService {
    constructor(public http: HttpClient) {
    }

    // function call to fetch Quick Call list
    public getQuickCallList() {
        let data =  this.http.get<QuickCallResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
             '/customer/quickcall?limit=-1');
        return data;
    }

    // public getQuickCallListforHomePage() {
    //     let data =  this.http.get<QuickCallResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
    //          '/customer/quickcall?limit=5');
    //     return data;
    // }
}
